import request from '@/utils/request'
import {applicationName} from '@/utils/const.js'

export function insert(data){
  return request({
    url:applicationName+'/admin/company',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function deleted(data){
  return request({
    url:applicationName+'/admin/company',
    method:'delete',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}


export function query(data){
  return request({
    url:applicationName+'/admin/company',
    method:'get',
    params:data
  })
}

export function queryList(data){
  return request({
    url:applicationName+'/admin/company/list',
    method:'get',
    params:data
  })
}

export function update(data){
  return request({
    url:applicationName+'/admin/company',
    method:'put',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function insertOrUpdateTitle(data){
  return request({
    url:applicationName+'/admin/company/iouTitle',
    method:'POST',
    headers:{
      "Content-Type":"application/json;charset=utf-8"
    },
    data:JSON.stringify(data)
  })
}

export function queryTitle(){
  return request({
    url:applicationName+'/admin/company/title',
    method:'get'
  })
}
